import { Fragment } from "react/jsx-runtime";

export default function TaskMobileNote(modalProps: any) {

  const id = modalProps?.id;
  const details = modalProps?.details;
  const employeeId = modalProps?.employeeId;
  const type = details?.task_type;
  console.log('details.employee_id == ', details.employee_id);
  console.log('employeeId == ', employeeId);

  return (
    <div style={{
      backgroundColor: '#fff3cd',
      border: '1px solid #ffeaa7',
      borderLeft: '4px solid #f39c12',
      borderRadius: '6px',
      padding: '16px 20px',
      margin: '16px 0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <span style={{
          fontSize: '20px',
          color: '#e67e22'
        }}>📱</span>
        <strong style={{
          color: '#d68910',
          fontSize: '16px',
          fontWeight: '600'
        }}>
          Mobile App Required
        </strong>
      </div>
      <p style={{
        margin: '0',
        color: '#856404',
        fontSize: '14px',
        lineHeight: '1.5'
      }}>
        <strong>Please note:</strong> This task must be completed in the mobile app by <strong>{details?.for}</strong>.
      </p>
    </div>
  );
}